// Admin route that uses the integrated admin dashboard
import AdminApp from './AdminApp';

export default function AdminRoute() {
  return <AdminApp />;
}

